var map = {
	"./__Amsterdam_0.jpeg": 1007,
	"./__Amsterdam_1.jpeg": 2488,
	"./__Amsterdam_10.jpeg": 5848,
	"./__Amsterdam_3.jpeg": 3090,
	"./__Bangladesh_0.jpeg": 1506,
	"./__Bangladesh_1.jpeg": 2361,
	"./__Bangladesh_10.jpeg": 8823,
	"./__Bangladesh_3.jpeg": 2463,
	"./__Lissabon_0.jpeg": 32,
	"./__Lissabon_1.jpeg": 4599,
	"./__Lissabon_10.jpeg": 465,
	"./__Lissabon_3.jpeg": 7137,
	"./__London_0.jpeg": 5061,
	"./__London_1.jpeg": 1726,
	"./__London_10.jpeg": 618,
	"./__London_3.jpeg": 2852,
	"./__NewYork_0.jpeg": 322,
	"./__NewYork_1.jpeg": 649,
	"./__NewYork_10.jpeg": 6887,
	"./__NewYork_3.jpeg": 7839,
	"./__Venedig_0.jpeg": 5843,
	"./__Venedig_1.jpeg": 1756,
	"./__Venedig_10.jpeg": 7124,
	"./__Venedig_3.jpeg": 3366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6731;